module.exports = __webpack_public_path__ + "static/media/3.6d2887d4.jpeg";